import { OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { HealthcheckStatusResult } from '../types'
import { usePayrollOpsFormStatus } from './config'

export const usePayrollOpsSurveyStatus = (
  org: OrganizationDetailFragment,
  _todo?: boolean
): Pick<HealthcheckStatusResult, 'status' | 'secondary'> => {
  const isComplete = usePayrollOpsFormStatus(org.id) === 'complete'

  return {
    status: isComplete ? 'complete' : 'incomplete',
    secondary: isComplete ? 'Payroll process questions answered' : 'Let us know about your payroll processes',
  }
}
